import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e4cf0444"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=e4cf0444&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=e4cf0444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports